import React from 'react';
import Modal from '@mui/material/Modal';
import { Typography } from '@mui/material';
import { styles } from './styles';
import { RecycleBinIcon } from '../icons/recycle-bin';
import Button from '@mui/material/Button';

type Props = {
    title: string;
    isOpen: boolean;
    onModalClose: () => void;
    paragraph: string;
    actions: { text: string; method: () => void; btnType: 'red' | 'grey' }[];
    startIcon?: JSX.Element;
};

export default function RemoveReleaseModal({ isOpen, onModalClose, paragraph, title, actions, startIcon }: Props) {
    const classes = styles();

    const handleClose = (event: Event) => {
        event.stopPropagation();
        onModalClose();
    };

    return (
        <>
            <Modal open={isOpen} onClose={handleClose} onClick={(event) => event.stopPropagation()}>
                <div data-cy="delete-campaign-modal" className={classes.modalContainer}>
                    <header className={classes.displyingCenter}>
                        <div>
                            <RecycleBinIcon style={{ fontSize: '60' }} className={classes.icon} />
                            <Typography variant="h3" className={`${classes.title} ${classes.marginBottom}`}>
                                {title}
                            </Typography>
                        </div>
                    </header>
                    <div className={classes.displyingCenter}>
                        <div>
                            <Typography variant="body1" paragraph className={classes.typography}>
                                {paragraph}
                            </Typography>
                        </div>
                    </div>
                    <footer className={classes.buttonsContainer}>
                        <Button
                            className={`${classes.buttonGrey} ${classes.button}`}
                            variant="contained"
                            onClick={onModalClose}
                            data-cy="cancel-button"
                        >
                            Cancel
                        </Button>
                        {actions.length > 0 &&
                            actions.map((action) => (
                                <Button
                                    startIcon={startIcon}
                                    className={`${action.btnType === 'grey' && classes.buttonGrey} ${
                                        action.btnType === 'red' && classes.buttonRed
                                    } ${classes.button}`}
                                    variant="contained"
                                    onClick={action.method}
                                    data-cy="delete-button"
                                >
                                    {action.text}
                                </Button>
                            ))}
                    </footer>
                </div>
            </Modal>
        </>
    );
}
